"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = require("@insided/shared/utils/globals");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _categories = require("@insided/shared/utils/categories");

var _CategorySection = _interopRequireDefault(require("./CategorySection"));

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Categories = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Categories, _Component);

  var _super = _createSuper(Categories);

  function Categories() {
    var _this;

    (0, _classCallCheck2.default)(this, Categories);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      collapsed: _this.props.collapsed,
      customCollapsedCategories: Object.keys(_this.props.collapsed).map(function (id) {
        return parseInt(id);
      }),
      categoriesV2: _this.props.categoriesV2
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCollapse", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e, id) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _context.next = 3;
                return _axios.default.get('/member/collapsed', {
                  params: {
                    type: 'categories',
                    id: id
                  }
                });

              case 3:
                _this.setState(function (prevState, props) {
                  var newCollapsedList = _objectSpread(_objectSpread({}, prevState.collapsed), {}, (0, _defineProperty2.default)({}, id, prevState.customCollapsedCategories.includes(id) ? !prevState.collapsed[id] : !props.isDefaultCollapsed));

                  return {
                    collapsed: newCollapsedList,
                    customCollapsedCategories: Object.keys(newCollapsedList).map(function (id) {
                      return parseInt(id);
                    })
                  };
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCategories", function (categoryId) {
      var category = (0, _categories.findCategoryById)(_this.props.categoriesV2, categoryId);

      if (category) {
        _this.setState({
          categoriesV2: [category]
        });
      }

      (0, _utils.scrollToCssSelector)('.category-and-topic-stream');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCategories", function () {
      _this.setState({
        categoriesV2: _this.props.categoriesV2
      });

      (0, _utils.scrollToCssSelector)('.category-and-topic-stream');
    });
    return _this;
  }

  (0, _createClass2.default)(Categories, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          attachmentCdn = _this$props.attachmentCdn,
          displayUnreadPostCount = _this$props.displayUnreadPostCount,
          unreadTopicsAndRepliesCount = _this$props.unreadTopicsAndRepliesCount,
          isDefaultCollapsed = _this$props.isDefaultCollapsed;
      var _this$state = this.state,
          customCollapsedCategories = _this$state.customCollapsedCategories,
          collapsed = _this$state.collapsed,
          categoriesV2 = _this$state.categoriesV2;
      return (0, _preact.h)("div", {
        className: "forum-list"
      }, categoriesV2 === null || categoriesV2 === void 0 ? void 0 : categoriesV2.map(function (parentCategory) {
        return (0, _preact.h)("div", {
          className: "box",
          key: "parent-category-".concat(parentCategory.id)
        }, (0, _preact.h)(_CategorySection.default, {
          resetCategories: _this2.resetCategories,
          setCategories: _this2.setCategories,
          parentCategory: parentCategory,
          displayUnreadPostCount: displayUnreadPostCount,
          attachmentCdn: attachmentCdn,
          handleCollapse: _this2.handleCollapse,
          unreadTopicsAndRepliesCount: unreadTopicsAndRepliesCount,
          isDefaultCollapsed: isDefaultCollapsed,
          collapsed: collapsed,
          customCollapsedCategories: customCollapsedCategories
        }));
      }), (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        return modules.includes('unreadPostCounter') && displayUnreadPostCount ? (0, _preact.h)("div", {
          className: "box"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/member/markAllForumsAsRead"))
        }, (0, _preact.h)(_phrase.default, {
          p: "Mark forums as read"
        }))) : null;
      }));
    }
  }]);
  return Categories;
}(_preact.Component);

var _default = Categories;
exports.default = _default;